import crypto from "crypto"
import jwt from "jsonwebtoken"

import { SECRET_KEY } from "../constants.js"
import executeQuery from "../lib/db.js"
import log from "../log.js"

interface UserLogin {
	email: string
	password: string
	app_id: number
}

interface iPermission {
	permission: string
}

export const getUsersByAppID = async ({ app_id }: { app_id: string }) => {
	log(`Getting users for app_id=${app_id}`)

	const query = `
		select
			user_id,
			display_name
		from
			users
		where
			user_id in (
				select
					distinct user_id
				from
					user_apps where app_id=${app_id}
			)
	`
	const users = await executeQuery({ query })

	return users
}

export const getUser = async ({ email, password, app_id }: UserLogin) => {
	log(`Attempting to get user with email=${email} and password=${password}`)

	const encryptedPassword = crypto.createHash("sha256").update(password).digest("hex")

	let user
	// let permissions

	try {
		const userQuery = `
			select
				user_id,
				email_address,
				display_name
			from
				users
			join
				user_apps using (user_id)
			where
				email_address='${email}'
				and password='${encryptedPassword}'
				and app_id=${app_id}
		`

		user = await executeQuery({ query: userQuery })
	} catch (err) {
		throw new Error(`Error executing userQuery: ${err instanceof Error ? err.message : String(err)}`)
	}

	log(`encrypted password: ${encryptedPassword}`)
	log(`user: ${JSON.stringify(user)}`)

	if (user.length === 0) {
		// no user found
		return null
	} else {
		const { user_id, email_address, display_name } = user[0]
		const token = jwt.sign({ user_id }, SECRET_KEY)

		return {
			userID: user_id,
			email: email_address,
			displayName: display_name,
			apps: await getUserApps({ user_id }),
			permissions: (await getUserAppPermissions({ user_id, app_id })).map(
				({ permission }: { permission: iPermission }) => permission,
			),
			token,
		}
	}
}

export const getUserApps = async ({ user_id }: { user_id: number }) => {
	log(`Get user apps for user_id=${user_id}`)

	// get list of apps
	const user_apps = await executeQuery({
		query:
			"select app_name, dev_url, prod_url from apps where app_id in (select app_id from user_apps where user_id=" +
			user_id +
			")",
	})

	return user_apps
}

export const getUserAppPermissions = async ({ user_id, app_id }: { user_id: number; app_id: number }) => {
	log(`Get user app permissions: user_id=${user_id}, app_id=${app_id}`)

	const app_permissions = await executeQuery({
		query: `
					select
						permission
					from
						app_permissions
					where
						app_id=${app_id}
						and permission_id in (
							select
								permission_id
							from
								user_permissions
							where
								user_id=${user_id}
						)
						and app_id in (
							select
								app_id
							from
								user_apps
							where
								user_id=${user_id}
						)
				`,
	})

	return app_permissions
}
